<script lang="ts">
import { sanitizeRichTextHtml } from '$lib/utils/sanitise.js';
import { prepareHtmlLinks } from '$lib/utils/url.js';

interface Props {
    content?: string;
    hideBlock?: boolean;
}

let { content = '', hideBlock = false }: Props = $props();
</script>

{#if !hideBlock && content}
    <div class="service-intro-text builder-text">
        {@html prepareHtmlLinks(sanitizeRichTextHtml(content))}
    </div>
{/if}

<style lang="scss">
    @use '/src/scss/mixins/builder-rich-text' as builder-mixins;
    @use 'sass-mq/mq' as *;

    .service-intro-text {
        color: var(--colour-dreamless-sleep);
        font-family: var(--font-secondary);
        font-size: 1.9rem;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 1.4;
        margin: 0;
        max-width: none;
        padding: 0;

        @include builder-mixins.rich-text-links;

        @include mq($from: tablet) {
            font-size: 3rem;
        }

        :global(p) {
            font: inherit;
            letter-spacing: inherit;
            line-height: inherit;
            margin: 0;
            text-wrap: pretty;
        }

        :global(p:not(:last-child)) {
            margin-bottom: 1.6rem;
        }
    }
</style>
